/* 10/22 손님 흐름 단계 기록(퍼널) — 화면마다 window.BGEV("단계", { q: 질문 번호, d: 몇 번째 칸 · 결제 수단 }) 한 줄로 부른다.
   서버(deploy/traffic.js /api/traffic/ev)가 정한 이름만 받아 funnel_events 에 남긴다. 보내는 것: 단계 · 질문 번호 · 칸 번호나 결제 수단 · 판 · 말씨 · 출처(page 만) · 탭 난수.
   입력값 · 로그인 아이디는 보내지 않는다. 같은 탭에서 같은 단계는 한 번만 보내고, 실패해도 화면에는 아무 일도 없다.
   탭 난수는 결제가 쓰는 그번 보기(sessionStorage bg.pay.sid — coin.js · 토스 결제창과 같은 값)라 서버가 결제 완료(paid)를 같은 탭에 잇는다. */
(() => {
  if (window.BGEV) return;
  const host = location.hostname, toss = /\.tossmini\.com$/.test(host);
  const off = !(toss || /(^|\.)bamgwabi\.com$/.test(host)) || navigator.webdriver || navigator.doNotTrack === "1" || navigator.globalPrivacyControl || /[?&](?:preview|debug)(?:[=&]|$)/.test(location.search);
  const url = (toss ? "https://bamgwabi.com" : "") + "/api/traffic/ev";   // 토스 미니앱은 다른 출처라 서버 주소로
  const ok = (v) => /^[A-Za-z0-9_-]{16,64}$/.test(v || "");
  const make = () => [...crypto.getRandomValues(new Uint8Array(16))].map((b) => b.toString(16).padStart(2, "0")).join("");
  // 탭에 적는 것(탭 난수 · 출처)은 방문 집계와 같은 규칙으로만 — 대한민국 접속이거나 측정 허용을 고른 브라우저면 서버가 <html data-bg-stats="store"> 를 붙인다(deploy/traffic.js trafficPage). 아니면 이 화면 것만
  let 적어도 = false; try { 적어도 = !off && document.documentElement.dataset.bgStats === "store"; } catch { /* 적지 않는다 */ }
  let mem = "";
  const sid = () => {
    try { const v = window.BGPAY?.head?.()["x-bg-session"]; if (ok(v)) return v; } catch { /* 결제 화면이 아니다 */ }
    try { let v = sessionStorage.getItem("bg.pay.sid"); if (!ok(v)) { if (!적어도) return (mem ||= make()); v = make(); sessionStorage.setItem("bg.pay.sid", v); } return v; } catch { return (mem ||= make()); }
  };
  // 출처 — 이 탭에 처음 들어온 주소의 utm · from 값, 없으면 들어온 곳의 호스트만(같은 사이트 안은 빼고). 홈에서 들어와도 무비의 page 에 실리게 탭에 적어 둔다
  const 깎기 = (v) => String(v || "").replace(/[^\p{L}\p{N}._@+-]/gu, "-").slice(0, 40);
  const 지금출처 = (() => {
    try {
      const p = new URLSearchParams(location.search), u = ["utm_source", "utm_medium", "utm_campaign"].map((k) => 깎기(p.get(k)));
      if (u.some(Boolean)) return "utm:" + u.join("/");
      if (p.get("from")) return "from:" + 깎기(p.get("from"));
      const r = document.referrer ? new URL(document.referrer).hostname : "";
      return r && r !== host && !/(^|\.)bamgwabi\.com$/.test(r) ? "ref:" + 깎기(r) : "";
    } catch { return ""; }
  })();
  try { if (적어도 && 지금출처 && !sessionStorage.getItem("bg.ev.src")) sessionStorage.setItem("bg.ev.src", 지금출처); } catch { /* 이 화면 것만 */ }
  const 출처 = () => { try { return sessionStorage.getItem("bg.ev.src") || 지금출처; } catch { return 지금출처; } };
  const 말씨 = () => { const v = String(window.BGLANG?.locale || document.documentElement.lang || "ko"); return /^[a-z]{2}(?:-[A-Za-z]{2})?$/.test(v) ? v : "ko"; };
  const 판 = async () => {
    if (toss) return "toss";
    if (/BamgwabiApp\//.test(navigator.userAgent || "")) return "ios";
    try { if (+(localStorage.getItem("bambee.twa") || 0) > 0 || document.referrer.startsWith("android-app://")) return "android"; } catch { /* 아래에서 */ }
    return (await window.BGPLAY?.ready?.().catch(() => false)) ? "android" : "web";
  };
  const sent = new Set();
  window.BGEV = (name, extra = {}) => {
    if (off) return;
    try {
      let q = extra.q;
      if (q == null) try { q = window.engineReq?.()?.questionId; } catch { q = ""; }
      q = String(q || "").slice(0, 48);
      const d = String(extra.d ?? "").slice(0, 16), key = `${name}|${q}|${d}`;
      if (sent.has(key)) return;
      sent.add(key);
      판().then((platform) => {
        const body = JSON.stringify({ name, q, d, session: sid(), platform, locale: 말씨(), ...(name === "page" ? { source: 출처() } : {}) });
        if (!navigator.sendBeacon?.(url, body)) fetch(url, { method: "POST", body, keepalive: true, credentials: "include" }).catch(() => {});
      }).catch(() => {});
    } catch { /* 기록 없이 */ }
  };
})();
